import type { QuizQuestion } from "../content/types";

function hashSeed(seed: number): number {
  let value = seed | 0;
  value ^= value << 13;
  value ^= value >>> 17;
  value ^= value << 5;
  return value >>> 0;
}

export function selectAssessmentQuestions(
  pool: QuizQuestion[],
  count: number,
  seed: number,
): QuizQuestion[] {
  if (count > pool.length) {
    throw new Error("Assessment question count exceeds the question pool");
  }

  const questions = [...pool];
  let state = seed || 1;
  for (let index = questions.length - 1; index > 0; index -= 1) {
    state = hashSeed(state);
    const swapIndex = state % (index + 1);
    [questions[index], questions[swapIndex]] = [
      questions[swapIndex],
      questions[index],
    ];
  }
  return questions.slice(0, count);
}

export function scoreAssessment(
  questions: QuizQuestion[],
  answers: Record<string, number>,
): number {
  if (questions.length === 0) {
    return 0;
  }
  const correct = questions.filter(
    (question) => answers[question.id] === question.correctIndex,
  ).length;
  return Math.round((correct / questions.length) * 100);
}
